// Re-export functions from the new utility modules for backward compatibility
export { 
  getReturnDeeplinkFromUrl, 
  getAppIdFromUrl, 
  getDecodedTokenFromUrl,
  storeAppIdFallback,
  getStoredAppIdFallback 
} from "./token-utils";

export { 
  getGameDataByAppId 
} from "./game-config-utils";

/**
 * Extracts the original checkout URL parameters and builds redirect URL
 */
export function buildRedirectUrl(status: 'success' | 'error', errorMessage?: string): string {
  const currentUrl = new URL(window.location.href);
  const baseUrl = `${currentUrl.origin}/return`;
  
  // Preserve all original parameters
  const params = new URLSearchParams(currentUrl.search);
  
  if (status === 'success') {
    params.set('success', 'true');
    // Remove any existing error parameter
    params.delete('error');
  } else {
    params.set('error', errorMessage || 'Payment failed');
    // Remove any existing success parameter
    params.delete('success');
  }
  
  return `${baseUrl}?${params.toString()}`;
}

/**
 * Validates if a URL is valid
 */
export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
